//import styles from "./Radio.module.scss";

function Radio({
  required = false,
  name,
  value,
  label,
  onChange,
  defaultValue,
  defaultChecked = false,
  className
}) {
  return (
    <>
      {/* <label className={styles.radio}> */}
      <label className={className}>
        <input
          type="radio"
          value={value}
          name={name}
          // className={styles.p}
          className={className}
          onChange={onChange}
          defaultValue={defaultValue}
          defaultChecked={defaultChecked}
          required={required}
        />
        <div></div>
        {/* <span className={label}>{label}</span> */}
        <span>{label}</span>
      </label>
    </>
  );
}

export default Radio;
